import React from 'react';
import { Modal, PillButton, Row, Stack, Text } from 'library/ui';

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    message: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmDialog = ({ open, title, message, onClose, onConfirm }: ConfirmDialogProps) => {
    if (!open) return null;

    return (
        <Modal title={title} onClose={onClose} width={440}>
            <Stack gap="md">
                <Text>{message}</Text>
                <Row justify="end" gap="sm">
                    <PillButton variant="secondary" onClick={onClose}>
                        Cancel
                    </PillButton>
                    <PillButton onClick={onConfirm}>OK</PillButton>
                </Row>
            </Stack>
        </Modal>
    );
};

export default ConfirmDialog;
